<template>
  <div v-if="$apollo.loading">
    <spinner />
  </div>
  <div v-else class="registration-success-page-container">
    <div class="registration-success-page">
      <span class="my-page-title">{{
        !hideTicketsForEvent3360 ? 'Zahtjev uspješno poslan' : $t('paymentSuccessful')
      }}</span>
      <span class="description">
        {{
          !hideTicketsForEvent3360
            ? 'Vaš zahtjev za bankovni transfer je uspješno zaprimljen. Svi detalji transakcije poslani su na vašu e-mail adresu.'
            : $t('ticketReady')
        }}
      </span>
      <div id="buttons-container">
        <a
          v-if="hideTicketsForEvent3360 && user && order"
          target="_blank"
          class="main-button v-btn v-btn--depressed v-btn--round theme--light primary"
          :href="`${customerURL}/orders/${order.uuid}`"
        >
          {{ $t('viewTheOrder') }}
        </a>
        <a
          v-if="hideTicketsForEvent3360"
          id="download-ticket"
          :class="{ 'v-btn--disabled': !ticketDownloaded }"
          class="main-button v-btn v-btn--depressed v-btn--round theme--light download-ticket"
          :disabled="!ticketDownloaded"
        >
          <span>{{ $t('getMyTicket') }}</span>
          <v-progress-circular
            v-show="!ticketDownloaded && !ticketError"
            color="primary"
            indeterminate
          />
        </a>
      </div>
      <button class="button-no-background" @click="goToPublicPage">
        {{ $t('backToEventPage') }}
      </button>
    </div>
    <div v-if="adsLoaded && ads.length" class="shop-section">
      <h4>CoreEvent partner ponuda</h4>
      <div class="shop-cards-section">
        <a
          v-for="ad in ads.slice(0, 3)"
          v-for-key="url"
          class="shop-card"
          target="_blank"
          :href="ad.url"
        >
          <img v-if="ad.logoUrl" class="logo-img" :src="ad.logoUrl" />
          <img class="product-img" :src="ad.imageUrl" />
          <div class="shop-card-details">
            <h5>{{ ad.title }}</h5>
          </div>
        </a>
      </div>
    </div>
    <div v-else-if="adsLoaded">
      <img src="/assets/successful-payment.svg" />
    </div>
  </div>
</template>

<script>
import { getEventAds, getEventSettings, getOrderInfoByUUID } from '@/http'
import axios from 'axios'
import { GET_LOGGED_USER } from '@/graphql/user.graphql'
import { customerURL, landingURL } from '@/utils'
import i18next from 'i18next'
import { attachQueryParamsToUrl } from '@/services/attach-query-params-to-url'
import { sendServerEvent } from '@/services/fbmeta.service'

export default {
  name: 'successful-payment',
  components: {},
  data() {
    return {
      slug: undefined,
      ticketDownloaded: false,
      ticketError: false,
      customerURL,
      landingURL,
      hideTicketsForEvent3360: false,
      user: null,
      order: null,
      ads: [],
      adsLoaded: false,
    }
  },
  async mounted() {
    const uuid = this.$router.history.current.params.orderUUID
    const lang = this.$router.history.current.params.lang || this.$route.query.lang
    localStorage.removeItem('order')
    this.order = await getOrderInfoByUUID(uuid)
    this.hideTicketsForEvent3360 = !this.order.purchases.every(p => Number(p.orderItemId) === 9454)

    i18next.changeLanguage(lang == 'en' ? 'en' : 'hr')
    await this.downloadTicket(uuid)
    const [{ slug, organization }, ads] = await Promise.all([
      getEventSettings(this.order.eventId),
      getEventAds(this.order.eventId),
    ])
    this.ads = (ads || []).map(a => {
      a.url = attachQueryParamsToUrl(a.url, {
        utm_source: 'CoreEvent',
        utm_campaign: 'Successful payment page',
        utm_content: `Event ${this.order.eventId}`,
      })

      return a
    })
    this.adsLoaded = true

    if (process.env.VUE_APP_ENVIRONMENT === 'production') {
      const [currency, value] = this.order.price.split(' ')
      const items = []
      this.order.purchases.map(p => {
        const existingItem = items.find(i => i.item_id === p.orderItemId)
        if (existingItem) {
          existingItem.quantity += 1
        } else {
          items.push({
            item_id: p.orderItemId,
            item_name: p.orderItem.name,
            price: Number(p.orderItem.price),
            quantity: 1,
          })
        }
      })

      this.slug = slug
      // await this.sendConversionApiEvent()
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          transaction_id: this.order.id,
          value: Number(value),
          currency,
          organization_id: organization.id,
          organization_slug: organization.slug,
          event_id: this.order.eventId,
          event_slug: this.slug,
          items,
        },
      })
    }

    const { data = {} } = await this.getUser()
    const { me: user } = data || {}
    this.user = user
  },
  methods: {
    async sendConversionApiEvent() {
      const email = this.order.buyer.fields.email

      await sendServerEvent({
        eventName: 'Purchase',
        email,
        price: this.order.price,
        eventId: this.order.eventId,
      })
    },
    goToPublicPage() {
      window.open(`${landingURL}/events/${this.slug}`, '_self')
    },
    async downloadTicket(uuid) {
      try {
        // TODO: fix this function for Facebook browser (and other embedded browsers)
        const lang = this.$router.history.current.params.lang || this.$route.query.lang || 'hr'
        const ticketName = lang == 'en' ? 'CoreEvent-tickets.pdf' : 'CoreEvent-karte.pdf'

        const { data: ticket } = await axios.get(
          `${process.env.VUE_APP_SERVER_URL}/files/tickets/${uuid}?lang=${lang}`,
        )

        const byteString = window.atob(ticket.body)
        const arrayBuffer = new ArrayBuffer(byteString.length)
        const int8Array = new Uint8Array(arrayBuffer)
        for (let i = 0; i < byteString.length; i++) {
          int8Array[i] = byteString.charCodeAt(i)
        }
        const blob = new Blob([int8Array], { type: 'application/pdf' })
        const url = URL.createObjectURL(blob)
        const downloadLink = document.getElementById('download-ticket')
        downloadLink.href = url
        downloadLink.setAttribute('download', ticketName)
        this.ticketDownloaded = true
      } catch (e) {
        this.ticketError = true
      }
    },
    async getUser() {
      return this.$apollo.query({
        query: GET_LOGGED_USER,
      })
    },
  },
}
</script>

<style scoped>
.button-no-background {
  font-family: Raleway;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: -0.015em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
}

.mt-50 {
  margin-top: 50px;
}

.my-page-title {
  font-family: Raleway, serif;
  font-style: normal;
  font-weight: bold;
  text-align: center;
  font-size: 2.25rem;
  line-height: 2.8rem;
  color: #0277bd;
  margin-bottom: 1.5rem;
  margin-top: 60px;
}

.app {
  background-image: url('/assets/background.png');
  background-position: right;
}

.registration-success-page-container {
  margin: auto;
  max-width: 1440px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 6rem;
}

.registration-success-page {
  align-items: flex-start;
  max-width: 30rem;
  display: flex;
  flex-direction: column;
}

.info-image {
  width: 100%;
  height: 30rem;
}

.description {
  font-family: Source Sans Pro, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 23px;
  color: #333333;
}

.mt-220 {
  margin-top: 220px;
}

#buttons-container {
  margin: 2rem 0;
  max-width: 640px !important;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 561px) {
  #buttons-container {
    flex-direction: column;
  }
}

@media screen and (max-width: 1187px) {
  .registration-success-page-container {
    padding: 0 1rem;
    justify-content: center;
    flex-direction: column;
  }

  .registration-success-page {
    padding-bottom: 4rem;
  }

  .registration-success-page-container .shop-section {
    max-width: 38rem;
    width: calc(100% + 2.5rem);
    align-self: flex-end;
    margin-right: -2.5rem;
    border-radius: 1.5rem 0 0 1.5rem;
  }

  .shop-cards-section {
    overflow-x: scroll;
  }
}

.download-ticket {
  background-color: white;
  border: 2px solid #0277bd;
  color: #0277bd;
}

.v-btn--disabled {
  border: none;
}

#download-ticket .v-progress-circular {
  margin-left: 10px;
}

.main-button {
  font-size: 16px;
  height: 36px;
  font-family: Raleway, sans-serif;
  font-weight: bold;
  line-height: 1.5;
}

.shop-section {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background: #cee4f2;
  border-radius: 1.5rem;
}

.shop-section h4 {
  font-family: 'Raleway';
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #0277bd;
  padding-bottom: 1.5rem;
}

.shop-cards-section {
  display: flex;
}

.shop-card:nth-of-type(1),
.shop-card:nth-of-type(2) {
  margin-right: 1.5rem;
}

.shop-card {
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  background: #f0f6fa;
  align-items: flex-start;
  max-width: 10.3rem;
}

.shop-card-details {
  padding: 16px 18px 24px;
}

.shop-card-details h5 {
  color: #0277bd;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
}

.shop-card .logo-img {
  position: absolute;
  height: 2rem;
  width: auto;
  max-width: 4rem;
  background: white;
  border-radius: 1rem 0;
}

.shop-card .product-img {
  border-radius: 1rem 1rem 0 0;
  height: 10.3rem;
  width: 10.3rem;
}
</style>
